export class PushSponsor {

    public id: string = "0";

    public sponsor_id: string; 
    public sponsor_name: string; 

    public title: string;
    public text: string;
    public url: string;

    public date_create: Date;
    public date_send: Date;
    public time_send: string;

    public sent: boolean;

    constructor() {}
}